// extracted by mini-css-extract-plugin
module.exports = {"withIcon":"_18NtLp","icon":"_2yzvyJ"};